// extracted by mini-css-extract-plugin
module.exports = {"accordion-item":"styles-module__accordion-item___126ze","blue-border":"styles-module__blue-border___2-kxy"};